import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const TranscriptIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 36 36" {...props}>
      {/* Mic circle */}
      <path
        d="M13.5 19.5c3.315 0 6-2.685 6-6s-2.685-6-6-6-6 2.685-6 6 2.685 6 6 6"
        fill="none"
        stroke="currentColor"
        strokeWidth={props.strokeWidth || 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Mic stand + base container */}
      <path
        d="M13.5 22.5c-4.005 0-12 2.01-12 6v3h24v-3c0-3.99-8.01-6-12-6"
        fill="none"
        stroke="currentColor"
        strokeWidth={props.strokeWidth || 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Voice wave 1 */}
      <path
        d="M25.14 18.945c3.03-3.03 3.03-7.605 0-10.905"
        fill="none"
        stroke="currentColor"
        strokeWidth={props.strokeWidth || 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Voice wave 2 */}
      <path
        d="M30.105 24c5.85-5.835 5.865-14.925 0-21"
        fill="none"
        stroke="currentColor"
        strokeWidth={props.strokeWidth || 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default TranscriptIcon;
